/* THIS FILE IS GENERATED. DO NOT EDIT */

import { DynamicStandaloneExtras, PropsFromComponent } from '@/types/component';
import { mergeProps } from '@/utils/merge';
import StandaloneTrendingMenu from 'sites/allas/components/standalone/TrendingMenu';

export const DynamicStandaloneTrendingMenu = StandaloneTrendingMenu;
export type DynamicStandaloneTrendingMenuProps = PropsFromComponent<typeof StandaloneTrendingMenu>;

export const DynamicStandaloneTrendingMenuWith = (extras: DynamicStandaloneExtras): typeof StandaloneTrendingMenu => {
    return function DynamicStandaloneTrendingMenu(props) {
        const theme = extras.theme.useTheme(extras.theme.key || 'TrendingMenu');
        return <StandaloneTrendingMenu {...mergeProps({ options: { theme } }, props)} />;
    }
}